module.exports = __webpack_public_path__ + "img/icon-close-white.7395f973.svg";